import supabase from '@/lib/supabase'
import {
  AI_LAB_ENABLED,
  DEFAULT_AI_LAB_MODELS,
  DEFAULT_AI_LAB_LEVEL,
} from '@/lib/config'

const ensureAiLabEnabled = () => {
  if (!AI_LAB_ENABLED) {
    throw new Error('AI Lab is currently disabled.')
  }
}

const handleFunctionResult = (result, functionName) => {
  if (result.error) {
    console.error(`${functionName} error`, result.error)
    throw new Error(result.error.message || `Failed to execute ${functionName}`)
  }
  return result.data
}

export async function listAiLabModels() {
  ensureAiLabEnabled()

  const result = await supabase.functions.invoke('ai-lab-models', {
    method: 'GET',
  })

  const data = handleFunctionResult(result, 'ai-lab-models')
  return data?.models ?? []
}

export async function fetchRecentAiLabRuns(limit = 10) {
  ensureAiLabEnabled()

  const result = await supabase.functions.invoke('ai-lab-run-history', {
    body: { limit },
  })

  const data = handleFunctionResult(result, 'ai-lab-run-history')
  return data?.runs ?? []
}

export async function startAiLabRun({
  models = DEFAULT_AI_LAB_MODELS,
  scenarios,
  associations,
  level = DEFAULT_AI_LAB_LEVEL,
} = {}) {
  ensureAiLabEnabled()

  const result = await supabase.functions.invoke('ai-lab-run', {
    body: {
      models,
      scenarios,
      associations,
      level,
    },
  })

  const data = handleFunctionResult(result, 'ai-lab-run')
  return data
}

export async function fetchAiLabRun(runId) {
  ensureAiLabEnabled()

  if (!runId) {
    throw new Error('runId is required')
  }

  const result = await supabase.functions.invoke('ai-lab-runs', {
    body: { id: runId },
  })

  return handleFunctionResult(result, 'ai-lab-runs')
}

export async function fetchAiLabSources() {
  ensureAiLabEnabled()

  const result = await supabase.functions.invoke('ai-lab-sources', {
    method: 'GET',
  })

  const data = handleFunctionResult(result, 'ai-lab-sources')
  return data?.sources ?? []
}


